import * as React from "react"
export const Svg_035 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M27.83 41.969c0 .92.749 1.67 1.67 1.67.921 0 1.67-.75 1.67-1.67v-2.061h-3.34v2.06Z"
    />
    <path fill="url(#b)" d="M24.545 32.994h9.91v3.457h-9.91v-3.457Z" />
    <path
      fill="url(#c)"
      d="M34.628 39.908v2.06c0 2.828-2.3 5.128-5.128 5.128a5.134 5.134 0 0 1-5.128-5.127v-2.061H4.706A8.118 8.118 0 0 1 0 38.41v16.551h59v-16.55a8.119 8.119 0 0 1-4.706 1.496H34.628Z"
    />
    <path
      fill="url(#d)"
      d="M4.706 36.45h16.382v-6.913h16.824v6.914h16.382A4.712 4.712 0 0 0 59 31.744V13.258H44.584V4.038H14.416v9.219H0v18.487a4.712 4.712 0 0 0 4.706 4.707ZM17.874 7.496h23.252v5.762H17.874V7.495Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={28.602}
        x2={30.455}
        y1={40.468}
        y2={43.153}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={26.837}
        x2={27.593}
        y1={33.512}
        y2={37.022}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={13.644}
        x2={16.602}
        y1={40.894}
        y2={57.962}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={13.644}
        x2={24.123}
        y1={8.9}
        y2={39.773}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)